/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.task.assignment.rpc.AssignedTasksRpc
 */

export const getAssignedTasksForUserRpc = {
  serviceName: 'com.hubspot.task.assignment.rpc.AssignedTasksRpc',
  rpcName: 'getAssignedTasksForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADnl6B2hQdsjZN3v2LSV3RK'
};